import { AxiosInstance } from 'axios'

export type Calculator = {
  id: string
  slug: string
  name: string
}
export function CalculatorsEndpoints(apiClient: AxiosInstance) {
  return {
    async listCalculators(): Promise<Calculator[]> {
      return apiClient.get('list-calculators')
    },
  }
}
